import { jsxs as t, jsx as a } from "react/jsx-runtime";
import { Text as o } from "@zapier/design-system";
const r = "_sidebarSectionTitle_7ku5i_1", l = "_apps_7ku5i_6", d = "_app_7ku5i_6", m = "_appIconContainer_7ku5i_16", _ = "_appIcon_7ku5i_16", n = {
  sidebarSectionTitle: r,
  apps: l,
  app: d,
  appIconContainer: m,
  appIcon: _
};
var v = function(c) {
  var p, s = c.template, e = (p = s.apps) === null || p === void 0 ? void 0 : p.items;
  return e?.length ? /* @__PURE__ */ t("section", { children: [
    /* @__PURE__ */ a(o, { type: "ParagraphHeader2", className: n.sidebarSectionTitle, tag: "h2", children: "Apps" }),
    /* @__PURE__ */ a("ul", { className: n.apps, children: e.map(function(i) {
      return /* @__PURE__ */ t("li", { className: n.app, children: [
        /* @__PURE__ */ a("div", { className: n.appIconContainer, children: /* @__PURE__ */ a("img", { className: n.appIcon, src: i.imageUrl, alt: "".concat(i.name, " icon") }) }),
        /* @__PURE__ */ a(o, { type: "Body3", children: i.name })
      ] }, i.slug);
    }) })
  ] }) : null;
};
export {
  v as AppsSection
};
//# sourceMappingURL=AppsSection.es.js.map
